import { render, staticRenderFns } from "./sidebar-category-menu.vue?vue&type=template&id=1ec97661&lang=pug&"
import script from "./sidebar-category-menu.vue?vue&type=script&lang=js&"
export * from "./sidebar-category-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports